import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-button-close',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  template: `
    <button mat-icon-button (click)="click.emit($event)"><mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon></button>
  `,
  styles: [],
})
export class ButtonCloseComponent {
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() click = new EventEmitter<Event>();
}
